import { SlotGameType1_21 } from '../SlotGameType1_21';

export class RoyalKing21 extends SlotGameType1_21
{
}
